var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrinter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28.5V34.5C30 36.99 27.99 39 25.5 39H22.5C20.01 39 18 36.99 18 34.5V28.5H30Z",
    fill: "#111827"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5V13.5C16.5 11.01 18.51 9 21 9H27C29.49 9 31.5 11.01 31.5 13.5V16.5H16.5Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 16.5H15C12 16.5 10.5 18 10.5 21V28.5C10.5 31.5 12 33 15 33H18V28.5H30V33H33C36 33 37.5 31.5 37.5 28.5V21C37.5 18 36 16.5 33 16.5ZM21 23.625H16.5C15.885 23.625 15.375 23.115 15.375 22.5C15.375 21.885 15.885 21.375 16.5 21.375H21C21.615 21.375 22.125 21.885 22.125 22.5C22.125 23.115 21.615 23.625 21 23.625Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 22.5C22.125 23.115 21.615 23.625 21 23.625H16.5C15.885 23.625 15.375 23.115 15.375 22.5C15.375 21.885 15.885 21.375 16.5 21.375H21C21.615 21.375 22.125 21.885 22.125 22.5Z",
    fill: "#111827"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 29.625H16.5C15.885 29.625 15.375 29.115 15.375 28.5C15.375 27.885 15.885 27.375 16.5 27.375H31.5C32.115 27.375 32.625 27.885 32.625 28.5C32.625 29.115 32.115 29.625 31.5 29.625Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.747f526fb922f868573bb723c501fb77.svg";
export { ForwardRef as ReactComponent };